module.exports = __webpack_public_path__ + "static/media/POST CONSTRUCTION_.447a1077.jpg";